// Keeps a phone's on-screen keyboard coming up when a field is focused after
// the tap that asked for it, not during it.
//
// iOS Safari only opens the keyboard for a focus() made inside the user's
// own tap handler. The search modal mounts on the render after the tap and
// focuses its field a frame later, so on an iPhone the field took focus with
// no keyboard, and the visitor had to tap it a second time. Focusing a
// throwaway field synchronously in the tap handler opens the keyboard; when
// the real field takes focus a moment later, the keyboard simply moves to it.
// Android Chrome does not need this, and it does no harm there.
//
// Call it only from a tap / click handler, and only on touch devices.
export function primeSoftKeyboard() {
  if (typeof document === "undefined") return;
  const input = document.createElement("input");
  input.type = "text";
  input.tabIndex = -1;
  input.setAttribute("aria-hidden", "true");
  // 16px so iOS does not zoom the page to it; fixed at the top so focusing
  // it scrolls nothing.
  input.style.cssText = [
    "position:fixed", "top:0", "left:0", "width:1px", "height:1px",
    "opacity:0", "border:0", "padding:0", "margin:0", "font-size:16px",
    "pointer-events:none",
  ].join(";");
  document.body.appendChild(input);
  try {
    input.focus({ preventScroll: true });
  } catch {
    input.focus();
  }
  // The real field takes focus well inside this; if it never does, removing
  // the stand-in blurs it and the keyboard closes again.
  window.setTimeout(() => input.remove(), 1500);
}
